<template>
    <header class="headBox">
        <div class="headMenu">
            <el-row>
                <el-col :xs="24" :span="8" >
                  <div class="navBox">
                    <ul class="nav">
                      <router-link class="logoBox cursor" tag="div" to="/">
                        <img class="logo" src="@/assets/img/head/logo.png" alt="">
                        <h1 class="text ellipsis">移动应用统一链接平台</h1>
                      </router-link>
                      <router-link v-if="tabsSwtich" class="item" to="/" exact >首页</router-link>
                      <router-link v-if="tabsSwtich" class="item" to="/documents" >文档中心</router-link>
                      <router-link v-if="$utils.getTerminal()=='pc'&&$utils.isEmpty(accountInfo)&&tabsSwtich" class="item" to="/console">控制台</router-link>
                    </ul>
                  </div>
                    <!-- <router-link class="logoBox cursor" tag="div" to="/">
                      <img class="logo" src="@/assets/img/head/logo.png" alt="">
                      <h1 class="text">统一链接</h1>
                    </router-link> -->
                </el-col>
                <el-col  v-if="tabsSwtich" :xs="24" :sm="{span:4,offset:12}">
                    <div class="navBox">
                      <ul class="nav">
                        <!-- <router-link class="item" to="/" exact >首页</router-link>
                        <router-link class="item" to="/documents" >文档中心</router-link> -->
                        <template v-if="$utils.isEmpty(accountInfo)">
                            <!-- <router-link v-if="$utils.getTerminal()=='pc'" class="item" to="/console">控制台</router-link> -->
                            <li class="item">
                              <div class="accountBox">
                                  <div class="account">
                                      <div class="accountText ellipsis">{{accountInfo.email}}</div>
                                  </div>
                                  <div class="accountOption">
                                    <!-- dataState:1-未完善 2-已完善 3-冻结 4-待审核 5-未通过 -->
                                    <template v-if="accountInfo.dataState==2">
                                      <!-- type:1-企业 2-个人 3-政府单位 -->
                                      <router-link class="item" to="/account/perfect/accountInfo" target="_blank">账号信息</router-link>
                                      <router-link class="item" to="/account/role/enterprise" >修改联系人信息</router-link>  
                                      <!-- <router-link v-else-if="accountInfo.type==3" class="item" to="/account/role/government" target="_blank">修改资料</router-link> -->
                                    </template>
                                    <template v-else>
                                      <router-link class="item" to="/account/perfect/status" target="_blank">修改资料</router-link>
                                    </template>
                                    <router-link class="item" to="/account/modify" target="_blank">修改账号邮箱</router-link>
                                    <router-link class="item" to="/account/password/change" target="_blank">修改密码</router-link>
                                    <li class="item" @click="logout">退出登录</li>
                                  </div>
                              </div>
                            </li>
                        </template>
                        <template v-else>
                          <router-link class="item " to="/account/login">登录</router-link>
                          <router-link class="item buleBtn " to="/account/register">注册</router-link>
                        </template>
                      </ul>
                    </div>
                </el-col>
            </el-row>
        </div>
    </header>
</template>

<script>
  export default {
    created(){
      this.$store.dispatch("accountStore/updateAccountInfo", {}).then((res) => {}).catch((res) => {});// 每次页面都去后台拿用户信息，更新本地状态
    },
    data() {
      return {
        tabsSwtich: true,//是否展示tabs导航开关
      };
    },
    computed: {
      accountInfo() {
        return this.$store.getters["accountStore/accountInfo"];//账户状态info
      },
    },
    watch: {
      '$route' (to, from){
        this.tabsSwtich = to.path.indexOf('account')==-1;//账户模块不需要 tabs导航
      }
    },
    methods: {
      // 登出
      logout() {
        this.$apis.accountSever.loginOut({
          token: this.accountInfo.token
        }).then(res => {
          if (res.code == 0) {
            localStorage.clear();
            this.$store.dispatch("accountStore/updateAccountInfo", {}).then(res => {//去后台拿账户信息，更新本地状态
            }).catch(()=>{});
            this.$router.push('/');
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
   .headBox{
      position: fixed;
      top:0;
      z-index: 10;
      width: 100%;
      min-height: 64px;
      line-height: 64px;
      font-size: 14px;
      background-color: $--background-color-base;
      border-bottom: 1px solid #ccc;
       h1, ul, ol { list-style:none; margin:0; padding:0;} 
      .ellipsis {
        vertical-align: middle;
        white-space: nowrap;
        word-break: keep-all;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .headMenu{
        height: 64px;
        .logoBox {
          display: flex;
          align-items: center;
          padding-left: 35px;
          margin-right: 30px;
          .logo{
              width: 24px;
              height: 24px;
          }
          .text{
              font-size: 14px;
              margin-left: 9px;
              color:#000 ;
          }
        }
        .navBox {
          display: flex;
          justify-content: flex-end;
          .nav{
            flex: 1;
            display: flex;
            .item{
              position: relative;
              flex: auto;
              color: #666;
              text-align: center;
              transition:color .3s;
              cursor: pointer;
              .accountBox {
                  position: relative;
                  display: flex;
                  justify-content: center;
                  height: 100%;
                  font-size: 14px;
                  cursor: pointer;
                  .account {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items:center ;
                    width: 158px;
                    height:60px;
                    text-align: center;
                    background-color: $--background-color-base;
                    z-index: 2;
                    .accountText {
                        position: relative;
                        padding:0 15%;
                        height: 34px;
                        border: 1px solid $--color-primary;
                        border-radius: 16px;
                        line-height: 32px;
                        color: $--color-primary;
                        &:after {
                          content: '';
                          position: absolute;
                          top: 40%;
                          right: 10px;
                          width: 8px;
                          height: 8px;
                          border-bottom: 1px solid $--color-primary;
                          border-left: 1px solid $--color-primary;
                          transform:rotate(-45deg)  translateY(-50%);
                        }
                    }
                  }
                  .accountOption {
                      position: absolute;
                      top: -999px;
                      left: 50%;
                      display: flex;
                      flex-wrap: wrap;
                      width: 158px;
                      border: 1px solid rgba(0,0,0,0.1);
                      // border-top: 4px solid $--color-primary;
                      border-radius:0px 0px 10px 10px;
                      line-height: 50px;
                      background-color: $--background-color-base;
                      transform: translateX(-50%);
                      transition: 0.5s top;
                      &::before {
                        content: '';
                        position: absolute;
                        top: -19px;
                        left: 50%;
                        transform: translateX(-50%);
                        border: 8px solid transparent; 
                        border-bottom: 8px solid $--color-primary;
                      }
                      .item{
                        position: relative;
                        text-align: left;
                        padding-left: 27px;
                        // &:after {
                        //   content: "";
                        //   position: absolute;
                        //   top: 50%;
                        //   left: 32px;
                        //   width: 3px;
                        //   height: 3px;
                        //   border: 1px solid #999;
                        //   transform:rotate(-45deg)  translateY(-50%);
                        //   background: #999;
                        // }
                      }
                      .item:hover {
                        color: $--color-primary;
                        &:after {
                          border: 1px solid $--color-primary;
                          background: $--color-primary;
                        }
                      }
                  }
                  &:hover .accountOption{
                    top: 100%;
                  }
                  &:hover .accountText{
                    color:$--color-white;
                    background-color: $--color-primary;
                    &:after {
                        border-bottom: 1px solid $--border-color-base;
                        border-left: 1px solid $--border-color-base;
                    }
                  }
              }
            }
            .item:hover{
              color: $--color-primary !important;
            }
            .buleBtn{
              background: #2E84FC;
              color: #fff!important;
            }
            .buleBtn:hover{
              color:#fff !important;
              font-weight: bolder;
            }
           .router-link-active, .router-link-exact-active{
              font-weight: bold;
              color: $--color-primary !important;
              // &:after {
              //   content: " ";
              //   width: 50px;
              //   height: 4px;
              //   background: $--color-primary;
              //   position: absolute;
              //   bottom: 20%;
              //   left: 50%;
              //   border-radius: 2px;
              //   -webkit-transform: translateX(-50%);
              //   transform: translateX(-50%);
              // }
            }
          }
        }
      }
   }
</style>
